import { styled, Typography } from '@mui/material';
import { Image } from '@mui/icons-material';
import { Controller } from 'react-hook-form';

import SamplePicturePanelProps from './SamplePicturePanelProps';

const NoImage = styled('div')`
  width: 100%;
  height: calc(100% - 97.5px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const SamplePicturePanel = ({ control }: SamplePicturePanelProps) => {
  return (
    <Controller
      name='samplePicture'
      control={control}
      render={({ field: { value } }) => (
        <>
          {value && <img src={value} />}
          {!value && (
            <NoImage>
              <Image fontSize='large' />
              <Typography>No Sample Picture</Typography>
            </NoImage>
          )}
        </>
      )}
    />
  );
};

export default SamplePicturePanel;
